import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex h-8 w-full rounded-[2px] border border-grey-500 bg-transparent px-1.5 text-xs text-white-100 placeholder:text-grey-300 focus-visible:outline-none focus-visible:border-grey-300 disabled:cursor-not-allowed disabled:bg-grey-650 disabled:border-grey-600 disabled:text-grey-300 disabled:placeholder:text-grey-300',
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Input.displayName = 'Input';

export { Input };
